export default __webpack_public_path__ + "static/media/ceramol-iage-cleansing-gel.3ceef886.png";